import { LegendTheme } from '../types';

export const legend: LegendTheme = {
  lineHeightClassName: 'line-height-22px',
  className: 'font-normal',
};
